import { STREAM_BASE } from '@/config';

export type ProbeResult = 'live' | 'exists' | 'absent' | 'timeout' | 'error';

/**
 * Probe a camera id via CORS fetch. The aegis server only sends CORS headers on
 * 200 responses, so an absent camera makes fetch THROW (caught -> 'absent').
 * A 200 master + a variant playlist with #EXTINF (no ENDLIST) => 'live'.
 */
export async function probe(
  id: string,
  timeoutMs: number,
  register?: (ac: AbortController) => void,
): Promise<ProbeResult> {
  const ac = new AbortController();
  const to = setTimeout(() => ac.abort(), timeoutMs);
  register?.(ac);
  try {
    const r = await fetch(`${STREAM_BASE}/${id}/master.m3u8`, { signal: ac.signal, cache: 'no-store' });
    if (r.status === 404 || r.status === 410) return 'absent';
    if (!r.ok) return 'error';
    const b = await r.text();
    if (!/#EXTM3U/.test(b)) return 'error';
    try {
      const r2 = await fetch(`${STREAM_BASE}/${id}/stream_0.m3u8`, { signal: ac.signal, cache: 'no-store' });
      if (r2.ok) {
        const t = await r2.text();
        if (/#EXTINF/.test(t) && !/#EXT-X-ENDLIST/.test(t)) return 'live';
      }
    } catch { /* variant unreachable — still "exists" */ }
    return 'exists';
  } catch (e) {
    return (e as Error).name === 'AbortError' ? 'timeout' : 'absent';
  } finally {
    clearTimeout(to);
  }
}
